import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { natterBreakpoints } from 'common/theme/breakpoints';
import { FeatureKey, isFeatureEnabled } from 'common/utils';

const isTablet = window.innerWidth < natterBreakpoints.desktop;

export interface AppState {
  displayDrawer: boolean;
  isDrawerCollapsed: boolean;
  darkTheme: boolean;
  scrollToTop: boolean;
  mobileMenuOpen: boolean;
  mobileBroadcastDrawerOpen: boolean;
  features: Partial<Record<FeatureKey, boolean>>;
}

const initialState: AppState = {
  displayDrawer: true,
  isDrawerCollapsed: isTablet,
  darkTheme: false,
  scrollToTop: false,
  mobileMenuOpen: false,
  mobileBroadcastDrawerOpen: false,
  features: {
    ReportingV2: isFeatureEnabled('ReportingV2'),
    SentryEnabled: isFeatureEnabled('SentryEnabled'),
    ReportFilters: isFeatureEnabled('ReportFilters'),
    DatadogEnabled: isFeatureEnabled('DatadogEnabled'),
    NatalieReporting: isFeatureEnabled('NatalieReporting'),
  },
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    appScrollToTop: (state) => {
      state.scrollToTop = true;
    },
    appScrollToTopDone: (state) => {
      state.scrollToTop = false;
    },
    appSetThemeDark: (state) => {
      state.darkTheme = true;
    },
    appSetThemeLight: (state) => {
      state.darkTheme = false;
    },
    appDrawerHide: (state) => {
      state.displayDrawer = false;
    },
    appDrawerShow: (state) => {
      state.displayDrawer = true;
    },
    appToggleMobileMenu: (state, { payload }: PayloadAction<boolean | undefined>) => {
      state.mobileMenuOpen = payload ?? !state.mobileMenuOpen;
    },
    appToggleMobileBroadcastDrawer: (state, { payload }: PayloadAction<boolean | undefined>) => {
      state.mobileBroadcastDrawerOpen = payload ?? !state.mobileBroadcastDrawerOpen;
    },
    appToggleDrawerCollapsed: (state, { payload }: PayloadAction<boolean | undefined>) => {
      state.isDrawerCollapsed = payload ?? !state.isDrawerCollapsed;
    },
    appToggleFeature: (state, { payload }: PayloadAction<FeatureKey>) => {
      state.features[payload] = !state.features[payload];
    },
  },
});

export const {
  appScrollToTop,
  appScrollToTopDone,
  appSetThemeDark,
  appSetThemeLight,
  appDrawerHide,
  appDrawerShow,
  appToggleMobileMenu,
  appToggleMobileBroadcastDrawer,
  appToggleDrawerCollapsed,
  appToggleFeature,
} = appSlice.actions;
